import {React, useState} from 'react';
import { useDispatch } from 'react-redux';
import { updateTableActions } from '../../store/update-table-slice';
import '../../App.css'
import { Grid, TextField, Box, Button, Paper, Stack,Typography} from '@mui/material';
import {Houseboat } from '@mui/icons-material';
import * as employeeService from '../../services/employeeService';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Notification from '../Notification';

// Custom component for required field label
const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red' , marginLeft: '3px'}}>*</span>
  </span>
);

const options = employeeService.getDepartmentCollection();

const initialFValues={
  id: 0,
  holidayYear: '',
  holidayDate: new Date(),
  holidayReason: '',
}

function EmployeeForm(){
  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});
  const [openPopup, setOpenPopup] = useState(false);
  const dispatch = useDispatch();
  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const navigate = useNavigate();

  const validate = () => {
    let temp = {}
    temp.holidayReason = values.holidayReason ? "" : "This field is required."

    setErrors({
      ...temp
    })

    return Object.values(temp).every(x => x == "")
  }

  const resetForm = () => {
    setValues(initialFValues);
    setErrors({});
  }



  function handleInputChange(e){
    const {name, value} = e.target;
    setValues({
      ...values,
      [name]: value
    })
    if (errors[name]) {
      setErrors({
          ...errors,
          [name]: ''
      });
  }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if(validate()){
      axios.post(`${process.env.REACT_APP_API_BASE_URL}/company-master/holiday-master/insert`, values)
      .then(function(response){
        if(response.status === 200) {
          setNotify({
            isOpen: true,
            message: response.data.message,
            type: 'success',
          });
          dispatch(updateTableActions.startUpdateCompanyHolidays());
        }
      }).catch(function(e){
        if(e.response.status === 401) {
          setNotify({
            isOpen: true,
            message: 'Session Expired!',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/');
          },1000);
        }
    });
    }
  }

  return(
    <Box sx={{display: "flex" ,justifyContent: "center", margin: "-20px", padding: "50px", fontWeight: "500px"}}>
      <Paper elevation={5} variant="outlined" sx={{width: "500px"}}>
        <Grid className="form-title" container spacing={2}>
          <Grid item> <Typography variant="h5" sx={{textAlign: "center", margin: 5}}>Company Holidays</Typography> </Grid>
          <Grid item> <Houseboat style={{marginLeft: "-40px"}} sx={{width: 45, height: 45}}/> </Grid>
        </Grid>
        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>

          <Stack spacing={4} sx={{margin: "30px"}}>            
            {/* <Stack className="right-aligned">
              <Button className="form-btn" variant="outlined" color="error" size="small" startIcon={<Preview sx={{width: "30px", height: "30px"}}/>}>Show</Button>
            </Stack> */}

            {/* <Stack className="center-aligned">
              <HolidayTable/>
            </Stack> */}

            <Stack className="form-input-row" direction="row">
              <TextField
                variant="outlined"
                name="holidayReason"
                label={<RequiredLabel label="Holiday Reason" />}
                size="small"
                value={values.holidayReason}
                onChange={handleInputChange}
                {...(errors.holidayReason && {error:true, helperText: errors.holidayReason} )}
              />

              <TextField
                variant="outlined"
                className="date-picker"
                type="date"
                label="Holiday Date"
                name="holidayDate"
                size="small"
                defaultValue="2017-05-24"
                value={values.holidayDate}
                onChange={handleInputChange}
              />
            </Stack>

            <Grid container className="space-around">
              <Grid item>
              <Button className="form-btn" variant="contained" disableElevation color="error" onClick={resetForm}>Reset</Button>
              </Grid>
              <Grid item>
              <Button className="form-btn" variant="contained" disableElevation type="submit">Submit</Button>
              </Grid>
            </Grid>

            </Stack>
        </form>
      </Paper>
      <Notification
        notify={notify}
        setNotify={setNotify} 
      />
    </Box>
  )
}

export default EmployeeForm;
